/*
 * Cross-store recovery (Half 2). Renders the Worker's `crossStore` block as a
 * bordered sister-store panel (Panel B) on the /search recovery page and (via
 * window.AICrossStore.injectDrawer) the predictive drawer. Fail-soft: any error
 * leaves the native experience untouched. Gated on window.AISearch.enabled.
 */
(function () {
  var cfg = window.AISearch || {};
  function ready() { return !!(cfg.enabled && cfg.url && cfg.tenant); }
  function endpoint(q) {
    return cfg.url.replace(/\/+$/, '') + '/api/search?tenant=' +
      encodeURIComponent(cfg.tenant) + '&q=' + encodeURIComponent(q);
  }

  // Fetch crossStore blocks for a query. Fail-soft: always resolves null on any error.
  function fetchCrossStore(query) {
    try {
      if (!ready() || !query || query.trim().length < 2) return Promise.resolve(null);
      return fetch(endpoint(query.trim()), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return window.AISearchShape ? window.AISearchShape.shapeResult(d, cfg.pins) : d; })
        .then(function (d) { return (d && d.crossStore && d.crossStore.length) ? d.crossStore : null; })
        .catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  var XSTORE_HOSTS = /^https:\/\/(www\.)?neuroganhealth\.com(\/|$)/i;
  function xstoreHref(url) { return (url && XSTORE_HOSTS.test(url)) ? url : '#'; }
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }
  function money(p) { return (typeof p === 'number') ? '$' + p.toFixed(2) : ''; }
  function initials(name) {
    return (name || '').split(/\s+/).map(function (w) { return w.charAt(0); }).join('').slice(0, 2).toUpperCase();
  }
  function stars(rating, count) {
    if (!count) return '';
    var full = Math.max(0, Math.min(5, Math.round(rating || 0)));
    return '<span class="ai-xstore__stars" aria-label="' + esc(rating) + ' out of 5">' +
      '★★★★★'.slice(0, full) + '<span class="ai-xstore__stars-empty">' + '★★★★★'.slice(full) + '</span></span>';
  }

  // Pure renderer: one crossStore block -> Panel B element (null if no products).
  // `compact` = drawer variant (2 products, no stars).
  function renderCrossStore(block, query, compact) {
    var products = (block.products || []).slice(0, compact ? 2 : 3);
    if (!products.length) return null;

    var panel = document.createElement('div');
    panel.className = 'ai-xstore' + (compact ? ' ai-xstore--compact' : '');
    panel.setAttribute('data-ai-xstore', block.tenant);

    var bar = document.createElement('div');
    bar.className = 'ai-xstore__bar';
    bar.innerHTML = '<span class="ai-xstore__badge">' + esc(initials(block.storeName)) + '</span>' +
      '<span class="ai-xstore__head">From <strong>' + esc(block.storeName) +
      '</strong> &mdash; carries &ldquo;' + esc(query) + '&rdquo;</span>';
    panel.appendChild(bar);

    var grid = document.createElement('div');
    grid.className = 'ai-xstore__grid';
    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'ai-xstore__card';
      a.href = xstoreHref(p.url);
      a.rel = 'noopener';
      a.setAttribute('data-ai-xstore-link', '1');
      a.setAttribute('data-ai-item', p.slug || '');
      a.setAttribute('data-ai-query', query);
      var imgW = compact ? 110 : 130;
      var img = p.image
        ? '<img class="ai-xstore__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="' + imgW + '" height="' + imgW + '">'
        : '<span class="ai-xstore__img ai-xstore__img--ph"></span>';
      a.innerHTML = img +
        (compact ? '' : stars(p.rating, p.ratingCount)) +
        '<span class="ai-xstore__title">' + esc(p.title) + '</span>' +
        '<span class="ai-xstore__price">' + money(p.price) + '</span>';
      grid.appendChild(a);
    });
    panel.appendChild(grid);

    var all = document.createElement('a');
    all.className = 'ai-xstore__all';
    all.href = xstoreHref(block.url);
    all.rel = 'noopener';
    all.setAttribute('data-ai-xstore-link', '1');
    all.setAttribute('data-ai-item', '__all__');
    all.setAttribute('data-ai-query', query);
    all.innerHTML = 'Shop all on ' + esc(block.storeName) + ' &rarr;';
    panel.appendChild(all);
    return panel;
  }

  // Log cross-store clicks BEFORE navigation (sendBeacon survives unload; links
  // leave to another domain). Capture-phase so theme handlers can't swallow it.
  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('[data-ai-xstore-link]') : null;
      if (!a) return;
      var A = window.AISearchAnalytics;
      if (A && A.track) {
        // Phase 3 CTR: carry the cross-store tier (high/soft) so clicks pair with
        // their impressions. Focus-mode links (ai-focus-search.js) stamp the tier;
        // the /search compact panel here does not, so it falls back to 'product'.
        A.track({ event_type: 'click', surface: 'cross-store',
                  item_kind: a.getAttribute('data-ai-xstore-tier') || 'product',
                  item_id: a.getAttribute('data-ai-item') || '', query: a.getAttribute('data-ai-query') || '' });
      }
      try {
        // Consent gate added 10 Aug 2026. This appends our session id to an outbound
        // neuroganhealth.com URL, i.e. it propagates an identifier across domains. Only
        // do that with analytics consent; without it the link is left clean.
        var stitchOk = false;
        try {
          var cp = window.Shopify && window.Shopify.customerPrivacy;
          stitchOk = !!(cp && cp.analyticsProcessingAllowed());
        } catch (e) {}
        if (stitchOk) {
          var sid = (window.AISearchAnalytics && window.AISearchAnalytics.sessionId) ? window.AISearchAnalytics.sessionId() : null;
          var dec = window.NeuroXStoreStitch && window.NeuroXStoreStitch.decorateXStoreHref;
          if (sid && dec && a.href) a.href = dec(a.href, sid);
        }
      } catch (e) {}
    } catch (err) {}
  }, true);

  // /search page: inject leading the results container when crossStore is present.
  function injectSearchPage() {
    try {
      if (!ready()) return;
      var meta = window.__nativeSearchMeta;
      if (!meta || !meta.terms) return;
      fetchCrossStore(meta.terms).then(function (blocks) {
        if (!blocks) return;
        var container = document.getElementById('ProductGridContainer');
        if (!container || container.querySelector('.ai-xstore')) return;
        blocks.slice().reverse().forEach(function (b) {
          var panel = renderCrossStore(b, meta.terms, false);
          if (panel) container.insertBefore(panel, container.firstChild);
        });
      }).catch(function () {});
    } catch (e) {}
  }

  // Drawer hook — called by predictive-search.js after it renders native results.
  // Sequence counter guards against stale responses from earlier keystrokes
  // overwriting fresher results when the user types quickly.
  var _drawerSeq = 0;
  function injectDrawer(query, resultsRoot) {
    if (!ready() || !resultsRoot) return;
    var seq = ++_drawerSeq;
    fetchCrossStore(query).then(function (blocks) {
      if (seq !== _drawerSeq) return;
      if (!blocks || resultsRoot.querySelector('.ai-xstore')) return;
      var target = resultsRoot.querySelector('.side-panel-content--tab-panel.tab-active') || resultsRoot;
      blocks.slice().reverse().forEach(function (b) {
        var panel = renderCrossStore(b, query, true);
        if (panel) target.insertBefore(panel, target.firstChild);
      });
    }).catch(function () {});
  }

  window.AICrossStore = { fetchCrossStore: fetchCrossStore, render: renderCrossStore, injectDrawer: injectDrawer };

  if (document.readyState !== 'loading') injectSearchPage();
  else document.addEventListener('DOMContentLoaded', injectSearchPage);
})();
